import ProdutosSection from '../components/ProdutosSection';
import bgVideo from '../assets/videos/bg-video.mp4';
import SobreUsinaRosa from '../components/SobreUsinaRosa';
import IndicacaoSection from '../components/IndicacaoSection';
import ContatoSection from '../components/ContatoSection';

export default function Home() {
  return (
    <main className="font-sans bg-[#f9fafb] text-gray-800">

      {/* 🎥 Vídeo de fundo com sobreposição escura */}
      <section className="relative h-[75vh] w-full overflow-hidden">
        <video
          className="absolute top-0 left-0 w-full h-full object-cover"
          src={bgVideo}
          autoPlay
          loop
          muted
          playsInline
        />
        <div className="absolute inset-0 bg-black/60 flex items-center justify-center text-white text-center px-6">
          <div className="max-w-3xl">
            <h1 className="text-4xl md:text-6xl font-bold mb-4">
              Excelência em Etanol, Inovação e Sustentabilidade
            </h1>
            <p className="text-lg md:text-xl">
              Produzimos energia limpa com compromisso ambiental e alta performance.
            </p>
          </div>
        </div>
      </section>

      <SobreUsinaRosa />

      {/* 🧪 Seção de Produtos com fundo verde claro */}
      <div className="bg-gradient-to-b from-white to-green-50 py-10 px-4">
        <ProdutosSection />
        <IndicacaoSection />
        <ContatoSection />
      </div>

      {/* 🟫 Rodapé ou bloco final futuro
      <footer className="bg-green-900 text-white py-8 text-center">
        <p>&copy; {new Date().getFullYear()} Usina Rosa. Todos os direitos reservados.</p>
      </footer>
      */}
    </main>
  );
}
